import atlasApi from '..'

import { isUserLoggedIn } from '@utils'

const orderPrefix = '/brands/v2/orders/'

const getOrder = async (id) => {
  if (isUserLoggedIn() !== null) {
    const response = await atlasApi.get(orderPrefix + id).catch((err) => err)

    return response
  } else {
    return 'User is logged in:' + isUserLoggedIn()
  }
}

const confirmOrder = async (id, data) => {
  return atlasApi.post(orderPrefix + id + '/approve', data)
}

export { getOrder, confirmOrder }
